import { FormatContent } from 'src/contexts/ContentContext';
import { FormatContentId } from 'src/utils/constants/formatContentId';

import * as styles from './BulkEditProgressDisplay.css';

interface GenericProgressDisplayProps {
  successPercent: number;
  successCount: number;
  warningPercent: number;
  warningCount: number;
  failurePercent: number;
  failureCount: number;
  totalCount: number;
}

export const GenericProgressDisplay = ({
  successCount,
  successPercent,
  warningCount,
  warningPercent,
  failureCount,
  failurePercent,
  totalCount,
}: GenericProgressDisplayProps) => {
  if (totalCount === 0) {
    return null;
  }
  return (
    <>
      {!!successPercent && (
        <div className={styles.textSuccess}>
          <FormatContent
            id={FormatContentId.NCompleted}
            params={`${successPercent * 100} / 100%`}
          />
        </div>
      )}
      {!!successCount && (
        <div className={styles.textSuccess}>
          <FormatContent
            id={FormatContentId.NCompleted}
            params={
              totalCount ? `${successCount} / ${totalCount}` : `${successCount}`
            }
          />
        </div>
      )}
      {!!warningPercent && (
        <div className={styles.textWarn}>
          <FormatContent
            id={FormatContentId.NWarnings}
            params={`${warningPercent * 100} / 100%`}
          />
        </div>
      )}
      {!!warningCount && (
        <div className={styles.textWarn}>
          <FormatContent
            id={FormatContentId.NWarnings}
            params={`${warningCount}`}
          />
        </div>
      )}
      {!!failurePercent && (
        <div className={styles.textError}>
          <FormatContent
            id={FormatContentId.NFailed}
            params={`${failurePercent * 100} / 100%`}
          />
        </div>
      )}
      {!!failureCount && (
        <div className={styles.textError}>
          <FormatContent
            id={FormatContentId.NFailed}
            params={`${failureCount}`}
          />
        </div>
      )}
    </>
  );
};
